import { useRef, useState } from "react";
import TopicsItem from "../../components/TopicsItem/TopicsItem";
import { Pagination } from "../../../../../../components";
import styles from "./TopicsAllPage.module.scss";
import { useTopicsPage } from "@podcasts/hooks";
import TopicsListItem from "../../components/TopicsItem/TopicsListItem";

export function TopicsAllPage({ title = "" }) {
  const myRef: any = useRef(null);
  const {
    data: { data, last_page, current_page },
    isSavedTopic,
    onPageChange,
    onSaveTopic,
  } = useTopicsPage({ per_page: 12, defaultOrder: "asc", order_by: "title" });

  const executeScroll = () =>
    myRef.current.scrollIntoView({ behavior: "smooth" });

  const [view, setView] = useState("grid");
  const [search, setSearch] = useState("");

  return (
    <>
      <div
        ref={myRef}
        className={`${styles["title-box"]} d-flex flex-column justify-content-between gap-10`}
      >
        <h2>{title}</h2>
      </div>
      {data.length ? (
        <>
          <div className={`${styles["topics-items"]}`}>
            {view === "grid" && (
              <>
                {data.map((item: any, i: number) => (
                  <div key={i} className={`${styles["topic-wrapp"]}`}>
                    <TopicsItem
                      {...item}
                      saved={isSavedTopic(item.id)}
                      onToggleFavorite={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        onSaveTopic(item);
                      }}
                    />
                  </div>
                ))}
              </>
            )}
            {view === "list" && (
              <>
                {data.map((item: any, i: number) => (
                  <TopicsListItem
                    {...item}
                    saved={isSavedTopic(item.id)}
                    onToggleFavorite={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      onSaveTopic(item);
                    }}
                  />
                ))}
              </>
            )}
          </div>
          <Pagination
            pages={last_page}
            page={current_page}
            onPageChange={(page: number) => {
              onPageChange(search, page);
              executeScroll();
            }}
          />
        </>
      ) : (
        <h3 className={`${styles["no-result"]}`}>
          No results. Please try a new search.
        </h3>
      )}
    </>
  );
}

export default TopicsAllPage;
